import { fetch } from '@/shared/fetch';
import {
    IOpenMessageConsultationRequest,
    IOpenMessageConsultationResponse,
} from '@/shared/interfaces';

export const createMessageConsultation = async (
    request: IOpenMessageConsultationRequest,
): Promise<IOpenMessageConsultationResponse> => {
    return await fetch<IOpenMessageConsultationResponse>(
        '/api/consultations/message',
        'POST',
        request,
    );
};
